import { CustomElement, resolve } from 'aurelia';
import { AccountService, CalendarService, SubscriptionService } from '../../services';
import template from './releases-panel.html';

// The right panel: the selected day's releases with a list/grid view toggle, the last-updated
// info popover, and pagination. The releases themselves render as <release> cards. Calendar
// state (selected day, view, pagination, updated-info) lives in CalendarService; the per-release
// bell state is read from SubscriptionService and gated by AccountService.isAuthenticated.
export class ReleasesPanelElement {
  readonly calendar: CalendarService = resolve(CalendarService);
  readonly account: AccountService = resolve(AccountService);
  readonly subscriptions: SubscriptionService = resolve(SubscriptionService);

  // The last-updated info popover container (button + popover), used to detect outside clicks.
  updatedInfoEl: HTMLElement | undefined;

  // Bound handler reference so we can add/remove the same listener across the element lifecycle.
  private readonly onDocumentPointerDown = (event: PointerEvent): void => {
    if (!this.calendar.updatedInfoOpen) return;
    const target = event.target as Node | null;
    // A click anywhere outside the info button/popover dismisses it (works on touch and mouse).
    if (this.updatedInfoEl && target && !this.updatedInfoEl.contains(target)) {
      this.calendar.closeUpdatedInfo();
    }
  };

  attached(): void {
    document.addEventListener('pointerdown', this.onDocumentPointerDown);
  }

  detaching(): void {
    document.removeEventListener('pointerdown', this.onDocumentPointerDown);
  }
}

export const ReleasesPanel = CustomElement.define({
  name: 'releases-panel',
  template,
  // Render the <aside> in place (no host wrapper) so it stays a direct grid child of .main-layout.
  containerless: true
}, ReleasesPanelElement);
